import FormData from "form-data";
import request from "../../utils/requests";
import confetti from "canvas-confetti";
import { AxiosError } from "axios";
interface DataForm {
  name: string;
  email: string;
  valor: number;
  botField: string;
}

export function isInProd(locationHostname: string) {
  const nonProd = ["local", "beta", "test"];
  const filteredHosts = nonProd.filter(
    (it) => locationHostname.includes(it) || /\d/.test(locationHostname)
  );
  return filteredHosts.length == 0;
}

export async function onSubmit({ name, email, valor, botField }: DataForm) {
  const patternEmail =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (
    name != "" &&
    patternEmail.test(email) == true &&
    botField == "" &&
    valor == 17
  ) {
    const data = new FormData();
    data.append("name", name);
    data.append("email", email);

    try {
      await request.post("/api/newsletter/subscribe", data);
      alert("Dados enviados com sucesso!");
      return confetti();
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error.response.status === 409) {
          return alert("Seu e-mail ja está cadastrado!");
        }
      } else {
        return alert("Erro ao enviar os dados para a FinanZero");
      }
    }
  } else {
    alert("Verifique suas informações e tente novamente.");
  }
}
